import {supabase} from '../supabase/supabase';

export const fetchSellerTaxReport=async(
  sellerId,
  startDate,
  endDate
)=>{
  const {data,error}=await supabase.rpc(
    'seller_get_tax_report_1793033000000',
    {
      p_seller_id:sellerId,
      p_start_date:startDate,
      p_end_date:endDate
    }
  );

  if (error) throw error;

  return Array.isArray(data) ? data : [];
};